<div class="send-report-form-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>
			{{ 'BUTTON.SEND' | translate }}
		</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content>
		<form [formGroup]="formGroup" class="pe-2 pt-2">
			<!-- <mat-form-field class="pb-3 w-100">
        <mat-label>{{ 'CONTRACT_NOTICES.CLIENTS' | translate }}</mat-label>
        <mat-chip-grid #clientsGrid aria-label="Clients selection">
          @for (client of selectedClients; track $index) {
          <mat-chip-row (removed)="action('REMOVE_ITEM', 'CLIENTS', client)">
            {{ client.name }}
            <button matChipRemove [attr.aria-label]="'remove ' + client.id">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          }
        </mat-chip-grid>

        <input #clientsInput matInput type="text" formControlName="clients" [matChipInputFor]="clientsGrid" [matChipInputSeparatorKeyCodes]="utils.CHIPS_SEPERATOR_KEYS" [matAutocomplete]="clientsAutocomplete" />
        <mat-autocomplete #clientsAutocomplete="matAutocomplete"(optionSelected)="action('ADD_ITEM', 'CLIENTS', $event)">
          @for (client of filteredClients; track $index) {
            <mat-option [value]="client">{{ client.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field> -->

			<mat-form-field class="pb-3 w-100">
				<mat-label>{{ 'CONTRACT_NOTICES.EMAILS' | translate }}</mat-label>
				<mat-chip-grid #emailsGrid aria-label="Emails selection">
					@for (email of selectedEmails; track $index) {
					<mat-chip-row (removed)="action('REMOVE_ITEM', 'EMAILS', email)">
						{{ email }}
						<button matChipRemove [attr.aria-label]="'remove ' + email">
							<mat-icon>cancel</mat-icon>
						</button>
					</mat-chip-row>
					}
				</mat-chip-grid>

				<input
					#emailsInput
					matInput
					type="text"
					formControlName="emails"
					[matChipInputFor]="emailsGrid"
					[matChipInputSeparatorKeyCodes]="utils.CHIPS_SEPERATOR_KEYS"
					(matChipInputTokenEnd)="action('ADD_ITEM', 'EMAILS', $event)"
					[matAutocomplete]="emailsAutocomplete" />
				<mat-autocomplete #emailsAutocomplete="matAutocomplete" (optionSelected)="action('ADD_ITEM', 'EMAILS', $event)">
					@for (email of filteredEmails; track $index) {
					<mat-option [value]="email">{{ email }}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="px-3">
		<mat-divider class="w-100 my-2"></mat-divider>

		<div class="d-flex pt-0">
			<button mat-flat-button color="primary" (click)="action('SEND')" [disabled]="!action('VALIDATION') || apiLoading">
				<div class="d-flex">
					@if(apiLoading) {
					<mat-spinner diameter="15" class="me-1"></mat-spinner>
					}
					<span>{{ 'BUTTON.SEND' | translate }}</span>
				</div>
			</button>
		</div>
	</mat-dialog-actions>
</div>
